import React from 'react'
import Wellness01 from './Wellness01'
import Wellness02 from './Wellness02'

const WellnessContent = () => {
    return (
        <>
            <Wellness01 />
            <Wellness02 />
        </>
    )
}

export default WellnessContent